import { Component, inject } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';
import { CheckboxComponent, DialogRef, ButtonDirective } from 'shared/ui-common';

import { ConcurrencyChangesDto, ConcurrencyChangeType, DIALOG_DATA } from '@treetop/shared/model';

export enum ConcurrencyChangesDialogType {
  MedicalComponent = 'Component',
  Guideline = 'Guideline',
}

@Component({
  selector: 'app-concurrency-changes-dialog',
  templateUrl: './concurrency-changes-dialog.component.html',
  styleUrls: ['./concurrency-changes-dialog.component.scss'],
  standalone: true,
  imports: [CheckboxComponent, ReactiveFormsModule, FormsModule, TranslocoPipe, ButtonDirective],
})
export class ConcurrencyChangesDialogComponent {
  public data: { type: ConcurrencyChangesDialogType; concurrencyChanges: ConcurrencyChangesDto } = inject(DIALOG_DATA) as {
    type: ConcurrencyChangesDialogType;
    concurrencyChanges: ConcurrencyChangesDto;
  };
  private dialogRef: DialogRef = inject(DialogRef);

  protected isCheckboxSelected = false;

  protected get message(): string {
    if (this.data.concurrencyChanges.type === ConcurrencyChangeType.Version) {
      return `ConcurrencyChanges${this.data.type}Version`;
    } else if (this.data.concurrencyChanges.type === ConcurrencyChangeType.State) {
      return `ConcurrencyChanges${this.data.type}State`;
    } else if (this.data.concurrencyChanges.type === ConcurrencyChangeType.Content) {
      return `ConcurrencyChanges${this.data.type}Content`;
    } else {
      return `ConcurrencyChanges${this.data.type}`;
    }
  }

  protected close(value: boolean): void {
    this.dialogRef.close(value);
  }

  protected ConcurrencyChangeType = ConcurrencyChangeType;
}
